/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Connectors({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1.66 11.676a2.76 2.76 0 0 1 5.147 1.56 5.24 5.24 0 0 0 3.661-1.34.6.6 0 1 1 .803.892 6.4 6.4 0 0 1-2.445 1.377 6.4 6.4 0 0 1-2.369.252l-.011.023a2.764 2.764 0 0 1-4.787-2.764m3.174.028a1.565 1.565 0 1 0-1.564 2.71 1.565 1.565 0 0 0 1.564-2.71m3.368-9.43a.6.6 0 0 1 .756-.385 6.429 6.429 0 0 1 3.816 3.354h.027a2.764 2.764 0 1 1-1.225.288 5.24 5.24 0 0 0-2.99-2.5.6.6 0 0 1-.384-.756M2.672.563a2.765 2.765 0 0 1 2.763 4.787 2.76 2.76 0 0 1-2.916-.097 5.24 5.24 0 0 0-.663 3.867.6.6 0 0 1-1.173.256 6.44 6.44 0 0 1 .99-5.017l-.014-.02A2.764 2.764 0 0 1 2.671.561m10.13 5.88a1.565 1.565 0 1 0 0 3.13 1.565 1.565 0 0 0 0-3.13M5.406 2.175a1.564 1.564 0 1 0-2.71 1.564 1.564 1.564 0 0 0 2.71-1.564" /></svg>;
}
;